import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-abastecimento-layout',
  standalone: false,
  templateUrl: './abastecimento-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './abastecimento-layout.component.css'
})
export class AbastecimentoLayoutComponent {
}
